import { render, staticRenderFns } from "./DivisionDetail.vue?vue&type=template&id=adb41d28&"
import script from "./DivisionDetail.vue?vue&type=script&lang=js&"
export * from "./DivisionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports